import type { RouteRecordRaw } from 'vue-router';

import { wrapRuntimeImport } from '@/shared/helpers/async.helpers';

export const AdminSuiteRoutes: RouteRecordRaw[] = [
    {
        path: '',
        component: wrapRuntimeImport(() => import('./screens/landing.vue')),
        meta: { admin: true }
    },
    {
        path: 'locations',
        component: wrapRuntimeImport(() => import('./screens/locations.vue')),
        meta: { admin: true }
    },
    {
        path: 'workstations',
        component: wrapRuntimeImport(() => import('./screens/workstations.vue')),
        meta: { admin: true }
    },
    {
        path: 'mobile-devices',
        component: wrapRuntimeImport(() => import('./screens/mobile-devices.vue')),
        meta: { admin: true }
    }
];
